exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".navHeader-title-uyN {\n    align-items: center;\n    display: inline-flex;\n    font-size: 1rem;\n    font-weight: 400;\n    padding: 0 0.5rem;\n    text-transform: capitalize;\n}\n", ""]);

// Exports
exports.locals = {
	"title": "navHeader-title-uyN"
};